import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as echarts from 'echarts'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { EssEnergyGrowthTrendChartData } from '../types'
import { colorArray } from './config'


export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: EssEnergyGrowthTrendChartData
}

const chart = ref()



watch(
  () => props.data,
  (newData: EssEnergyGrowthTrendChartData | undefined) => {
    if (chart.value && newData) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      console.log()
      if (chartInstance) {
        chartInstance.setOption({
          xAxis: [
            {
              data: newData.xAxisData || [],
            },
          ],
          series: newData.seriesData?.map((series, index) => {
            return {
              ...chartOption.value.series[0],
              name: newData.seriesData ? newData.seriesData[index].name : series.name,
              data: newData.seriesData ? newData.seriesData[index].data : [],
            }
          }),
        })
      }
    }
  },
  { immediate: true, deep: true },
)

onMounted(() => {
  window.addEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
onUnmounted(() => {
  // 清理事件监听
  window.removeEventListener('resize', () => {
    if (chart.value) {
      const chartInstance = echarts.getInstanceByDom(chart.value)
      if (chartInstance) {
        chartInstance.resize()
      }
    }
  })
})

// ECharts 的配置项
const chartOption = computed(() => {
  return {
    color: colorArray,
    // 提示框
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        animation: false,
      },
    },

    // 坐标轴
    axisPointer: {
      link: [{ xAxisIndex: 'all' }],
    },

    // 网格
    grid: {
      top: '10%',
      left: '8%', // 为左侧 Y 轴留出空间
      right: '8%', // 为右侧 Y 轴留出空间
      bottom: '15%', // 为下方的 dataZoom 留出空间
    },

    // X 轴
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: [],
      axisLine: { show: false },
      axisLabel: { show: false },
      axisTick: { show: false },
      splitLine: {
        // X轴的网格线（垂直线）
        show: true,
        lineStyle: {
          color: '#444',
          type: 'dashed',
        },
      },
    },

    // Y 轴 (双Y轴配置)
    yAxis: [
      {
        // 左侧Y轴
        type: 'value',
        // max: 400,
        axisLabel: { color: '#ccc' },
        axisLine: { show: false },
        splitLine: { show: false }, // 通常只显示一个方向的网格线
      },
      {
        // 右侧Y轴
        type: 'value',
        max: 100, // 百分比最大值
        axisLabel: {
          color: '#ccc',
          formatter: '{value} %', // 格式化标签
        },
        axisLine: { show: false },
        splitLine: { show: false },
      },
    ],

    // 下方的缩放/时间轴组件
    dataZoom: [
      {
        type: 'slider',
        xAxisIndex: 0,
        filterMode: 'filter',
        start: 0,
        end: 100,
        bottom: '2%',
        height: 20,
        handleStyle: {
          color: '#fff',
        },
        textStyle: {
          color: '#ccc',
        },
        borderColor: '#555',
      },
    ],

    // 系列
    series: [
      {
        name: '',
        type: 'line',
        smooth: true,
        showSymbol: false,
        yAxisIndex: 0, // 关联到左侧Y轴
        data: [],

        // 标记区域
        // markArea: {
        //   itemStyle: {
        //     color: 'rgba(255, 173, 177, 0.2)' // 橙色半透明
        //   },
        //   data: [
        //     [
        //       { name: '高亮时段', xAxis: '00:08' }, // 标记区域的起始点
        //       { xAxis: '00:11' } // 标记区域的结束点
        //     ]
        //   ],
        //   label: {
        //     color: '#ccc',
        //     position: 'bottom',
        //     formatter: '{b}\n00:30', // 自定义标签内容，\n换行
        //     lineHeight: 16
        //   }
        // }
      },
      {
        name: '',
        type: 'line',
        smooth: true,
        showSymbol: false,
        yAxisIndex: 1, // 关联到右侧Y轴 (百分比)
        data: [],
      },
    ],
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"100%","height":"100%"},
    ref_key: "chart",
    ref: chart
  }, null, 512))
}
}

})